/**
 * Shared lucky draw data for checkout and Lucky Draw page.
 * Replace with API call (e.g. GET /lucky-draw/upcoming) when backend is ready.
 */
export const UPCOMING_DRAWS = [
  {
    id: 1,
    title: 'Car Lucky Draw',
    category: 'Cars',
    prize: 'Hyundai i10',
    prizeValue: 500000,
    drawDate: '2024-02-15',
    drawTime: '18:00',
    participants: 1250,
    maxParticipants: 5000,
    ticketPrice: 100,
    description: 'Win a brand new Hyundai i10! Purchase tickets to enter the draw.',
    status: 'active',
  },
  {
    id: 2,
    title: 'Bike Lucky Draw',
    category: 'Bikes',
    prize: 'Honda Activa',
    prizeValue: 75000,
    drawDate: '2024-02-20',
    drawTime: '19:00',
    participants: 890,
    maxParticipants: 3000,
    ticketPrice: 50,
    description: 'Win a Honda Activa! Get your tickets now.',
    status: 'active',
  },
  {
    id: 3,
    title: 'Premium Car Draw',
    category: 'Cars',
    prize: 'Maruti Swift',
    prizeValue: 650000,
    drawDate: '2024-02-25',
    drawTime: '20:00',
    participants: 2100,
    maxParticipants: 10000,
    ticketPrice: 200,
    description: 'Premium lucky draw for Maruti Swift. Limited tickets available!',
    status: 'active',
  },
];

/** Get active draws (for checkout / API replacement point) */
export function getActiveDraws() {
  return UPCOMING_DRAWS.filter((d) => d.status === 'active');
}
